import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import getLink, { LINK_TYPE } from "@/lib/links";
import img from "../../assets/img/auth_layout.png";
import SelectHotelInput from "./SelectHotelInput";

export default function SelectHotelForm() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	function goNext() {
		navigate(getLink(LINK_TYPE.REGISTER_USER));
	}

	return (
		<div className="mx-auto max-w-sm w-full">
			<Button
				className="md:hidden mb-8"
				variant={"default"}
				onClick={() => navigate(getLink(LINK_TYPE.LOGIN))}
			>
				<ArrowLeft className="mr-2 h-4 w-4" /> {t("auth.back")}
			</Button>
			<p className="text-xl font-medium">{t("auth.selectHotel_title")}</p>
			<p className="text-base font-medium text-gray-500">
				{t("auth.selectHotel_subtitle")}
			</p>
			<div className="mt-10">
				<div className="relative w-full">
					<SelectHotelInput
						onSubmit={goNext}
						buttonLabel={t("auth.selectHotel_action")}
					/>

					{/* <div
            style={{
              width: "100%",

              // height: "calc(75vh)",
              background: `url(${img})`,
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            }}
            className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
          ></div> */}
					<div className="mt-4 text-sm">
						<img src={img} className="lg:hidden" />
						<div className="mt-4 text-sm">
							{t("auth.login_ask")}{" "}
							<Link
								to={getLink(LINK_TYPE.LOGIN)}
								className="underline font-medium"
							>
								{t("auth.login_button")}
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
